import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _JSXStyle from "styled-jsx/style";
import { useMemo, useRef } from 'react';
import { liftA } from '@cullylarson/f';
import { useUpdate } from '@@client/lib/hooks';
import { getMessage } from '@@client/lib/messages';
import { classnames } from '@@client/lib/classes';
export default function Messages(_ref) {
  var error = _ref.error,
      success = _ref.success,
      notice = _ref.notice,
      _ref$scrollOnMessages = _ref.scrollOnMessages,
      scrollOnMessages = _ref$scrollOnMessages === void 0 ? true : _ref$scrollOnMessages;
  var ref = useRef(null);
  var errorFiltered = useMemo(function () {
    return liftA(error).filter(function (x) {
      return !!x;
    });
  }, [error]);
  var successFiltered = useMemo(function () {
    return liftA(success).filter(function (x) {
      return !!x;
    });
  }, [success]);
  var noticeFiltered = useMemo(function () {
    return liftA(notice).filter(function (x) {
      return !!x;
    });
  }, [notice]); // scroll into view, if we have messages

  useUpdate(function () {
    if (!scrollOnMessages) return;
    if (!ref.current) return;

    if (errorFiltered.length || successFiltered.length || noticeFiltered.length) {
      ref.current.scrollIntoView(true);
    }
  }, [error, success, notice]);

  var renderSet = function renderSet(classNames, role, messages) {
    classNames = classnames([].concat(_toConsumableArray(liftA(classNames)), ['messages']));
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("ul", {
        ref: ref,
        role: role,
        "aria-live": role === 'alert' ? 'assertive' : 'polite',
        className: "jsx-2849433836" + " " + (classNames || ""),
        children: messages.map(function (x, i) {
          return /*#__PURE__*/_jsx("li", {
            className: "jsx-2849433836",
            children: getMessage(x)
          }, i);
        })
      }), /*#__PURE__*/_jsx(_JSXStyle, {
        id: "2849433836",
        children: [".messages.jsx-2849433836{list-style:none;padding:20px;max-width:500px;font-weight:600;}", ".messages.error.jsx-2849433836{color:white;background:#D0021B;}", ".messages.success.jsx-2849433836{color:white;background:rgb(54,179,126);}", ".messages.notice.jsx-2849433836{color:#333;background:#FFF19B;}"]
      })]
    });
  };

  var renderOne = function renderOne(error, success, notice) {
    if (error && error.length) return renderSet('error', 'alert', error);else if (success && success.length) return renderSet('success', 'status', success);else if (notice && notice.length) return renderSet('notice', 'status', notice);else return null;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderOne(errorFiltered, successFiltered, noticeFiltered)
  });
}